<template>
  <div class="dropdown">
    <button
        @click="toggleMenu()"
        class="dropbtn tw-bg-gray-700 tw-border-none tw-text-white tw-rounded-full tw-text-xl tw-h-10 tw-w-10 tw-cursor-pointer tw-flex tw-justify-center tw-items-center tw-mr-[10px] hover:tw-bg-gray-600 tw-transition-colors"
    >
      {{ label }}
    </button>
    <div id="myDropdown" :class="'dropdown-content tw-rounded-lg tw-z-[3] ' + align">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      required: false,
      default: "text-center",
    },
    label: {
      required: false,
      default: "⬇️",
    },
  },
  methods: {
    toggleMenu() {
      document.getElementById("myDropdown").classList.toggle("showSplitButton");
    },
  },
  mounted() {
    document.body.addEventListener("click", (event) => {
      if (!event.target.matches(".dropbtn")) {
        var dropdowns = document.getElementsByClassName("dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];

          if (openDropdown.id === "myDropdown") return;

          if (openDropdown.classList.contains("showSplitButton")) {
            openDropdown.classList.remove("showSplitButton");
          }
        }
      }
    });
  },
};
</script>

<style>
#cardDesigner {
  .dropdown {
    position: relative;
    display: inline-block;
  }

  .dropdown-content {
    left: -150px;
    display: none;
    position: absolute;
    background-color: var(--color-bg-split-button);
    min-width: 160px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.1);
    z-index: 1;
  }

  .dropdown-content > div {
    color: var(--color-text-on-dark-soft);
    transition: background-color 0.2s ease;
  }

  .dropdown-content > div:hover {
    background-color: var(--color-bg-split-button-hover);
  }

  .dropdown-content a {
    color: var(--color-text-on-dark-soft);
    padding: 15px 20px;
    text-decoration: none;
    display: block;
  }

  .dropdown a:hover {
    background-color: var(--color-bg-split-button-hover);
  }

  .showSplitButton {
    display: block;
    top: -150px;
  }
}
</style>
